import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgShare = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10a4 4 0 1 0-3.9-3.108L9.105 9.478a4 4 0 1 0-.183 5.255l5.154 2.485a4 4 0 1 0 .87-1.801L9.88 12.974a4.009 4.009 0 0 0 .059-1.676l5.08-2.63A3.99 3.99 0 0 0 18 10Zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM6 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm10 4a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z", fill: color }));
};
export default factorySvgIcon(SvgShare);
//# sourceMappingURL=SvgShare.js.map